if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');         
      if(!this.form) return;
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.error = false;

      if (!this.submitButton) return;
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (this.submitButton.hasAttribute('disabled')) return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);   
      
       if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

      
      config.body = formData;
    

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.error = true;
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            return;
          } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
            console.log(Object.fromEntries(formData.entries()));
        })
        .catch((e) => {
          this.error = true;
          console.error(e);
        })
        .finally(() => {
          if (!this.submitButton) return;

          this.submitButton.classList.remove('loading');
          const loadingSpinner = this.querySelector('.loading-overlay__spinner');
          if (loadingSpinner) loadingSpinner.classList.add('hidden');

          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }

          if (!this.error) {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.removeAttribute('disabled');
          }

          setTimeout(function(){
         	giftCart();
          }, 1000); 
        });
    }

    handleErrorMessage(errorMessage = false) {
       if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

$(document).ajaxComplete(function() {
//  CartJS.updateCart();
});


function giftCart() {
  const cartItems = document.querySelectorAll('tr.cart-item');
    cartItems.forEach(cartItem => {        
        const dataId = cartItem.getAttribute('data-id');
        const drawerFooter = document.querySelector(`#Gift-Wrapper[data-id="${dataId}"]`);  
      if(!drawerFooter) return;
      const drawerFooterID = drawerFooter.getAttribute('data-id');
        if(drawerFooterID == dataId) {            
            drawerFooter.classList.add('Gift-Wrapper__hide'); 
        }
    });
}



